import { Contact } from './contact.model';

export class BatchText {
  body: string;
  senderName: string;
  members: number[];
  scheduleTime: Date;
}

export class DirectBatchText {
  body: string;
  senderName: string;
  contacts: Contact[];
  scheduleTime: Date;
}
 